import {ComponentStyleConfig} from "@chakra-ui/react";

const CardHeader:Partial<ComponentStyleConfig> = {
  baseStyle: {
    display: "flex",
    width: "100%"
  },
};

export const CardHeaderComponent:any = {
  components: {
    CardHeader,
  },
};
